import { HelperCodes } from "custom-models";

import { GET_MACRO_HELPERS_SUCCESS } from "../actions/constants";

export const initialState: HelperCodes = {
  front: {},
  comment: {},
  margin: {},
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_MACRO_HELPERS_SUCCESS:
      return action.payload.response;
    default:
      return state;
  }
};
export default reducer;
